// Material
import { Button, Typography } from '@mui/material'
import { SxProps, styled } from '@mui/material/styles'
import { ExpandMoreIcon } from '@weblite/icons'
import { Alert } from '$common/input/alert'
// Icons
// Localization
import { nothing } from '$func/utils'
import { t } from '$i18n'
import { MuiCircularLoading } from '$common/loading/mui-circular-loading'

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  padding: '8px 10px',
  borderRadius: '12px',
  border: `1px solid  ${theme.palette.neutral300}`,
  background: theme.palette.neutral000,
  '&:hover': {
    borderColor: theme.palette.primary500,
  },
  '& .MuiButton-endIcon': {
    marginLeft: '2px',
    marginTop: '1px',
    color: theme.palette.neutral500,
    '& > .MuiBox-root': {
      margin: 0,
    },
  },
  '&.Mui-disabled': {
    border: `1px solid ${theme.palette.neutral200}`,
    '& svg': {
      opacity: 0.8,
    },
  },
}))

export function SelectButton({
  value,
  onClick,
  placeholder,
  hasError,
  errorMessage,
  className,
  sx,
  disabled,
  loading,
}: {
  value?: string
  onClick?: () => unknown // TODO: Make it required later
  placeholder?: string
  hasError?: boolean
  errorMessage?: string
  className?: string
  sx?: SxProps
  disabled?: boolean
  loading?: boolean
}) {
  return (
    <>
      <StyledButton
        className={className}
        sx={sx}
        endIcon={
          loading ? (
            <MuiCircularLoading size={17} color="inherit" />
          ) : (
            <ExpandMoreIcon sx={{ width: '24px', height: '24px' }} />
          )
        }
        onClick={onClick}
        disabled={disabled}
      >
        <Typography
          variant="body2"
          color={value ? 'semiBlack' : 'semiLightGray'}
        >
          {value || placeholder || t('myAccountEdit.pleaseSelect')}
        </Typography>
      </StyledButton>

      {hasError && <Alert variant="error" text={errorMessage} />}
    </>
  )
}

SelectButton.defaultProps = {
  value: '',
  onClick: nothing,
  placeholder: '',
  hasError: false,
  errorMessage: '',
}
